import merge from 'lodash/merge';
import { Pipe, PipeTransform } from '@angular/core';
import { STATES } from '../lib/states';

@Pipe({ name: 'state' })
export class StatePipe implements PipeTransform {
  private allStates = merge({}, STATES['United States'], STATES['Canada'], STATES['Mexico']);
  public transform(abbr: string): string {
    return this.allStates[abbr];
  }
}
